import { RootAppState } from 'store/configureStore'

// deprecated
export const ProjectInBuyerViewSelector = (state: RootAppState) => {
  return state.project?.activeProject?.isBuyingPartyView
}
